export const FETCH_GTD_LOGS_SUCCESS = 'FETCH_GTD_LOGS_SUCCESS';
export const FETCHING_GTD_LOGS = 'FETCHING_GTD_LOGS';
export const FETCH_SELECTED_LOG_INFORMATION = 'FETCH_SELECTED_LOG_INFORMATION';
export const FETCHING_SELECTED_LOG_INFORMATION = 'FETCHING_SELECTED_LOG_INFORMATION';


// WEBPACK FOOTER //
// ./src/redux/logs/LogConstants.js